import { useQuery } from "@tanstack/react-query";
export const createJudgingProgrammesQueries = (requests, queryClient) => ({
    useListJudgingProgrammes: (params, options = {}) => useQuery({
        queryKey: ["judging-programmes", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listJudgingProgrammes(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map